import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import { useAuth } from '../../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../components/LanguageSwitcher/LanguageSwitcher';
import * as S from '../Header.styles';

interface DesktopHeaderProps {
  isTwoColumnsLayout: boolean;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({ isTwoColumnsLayout }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { isInitialized, isAuthenticated, userName, login, logout, register } = useAuth();

  const handleLogin = async () => {
    // Always use English locale for Keycloak regardless of app language
    console.log('[DesktopHeader] Current app language:', i18n.language);
    console.log('[DesktopHeader] Keycloak locale: en (fixed)');
    await login('en');
  };

  const handleRegister = async () => {
    // Always use English locale for Keycloak regardless of app language
    console.log('[DesktopHeader] Current app language:', i18n.language);
    console.log('[DesktopHeader] Keycloak locale: en (fixed)');
    await register('en');
  };

  const handleLogout = async () => {
    await logout();
  };

  // User menu for authenticated users
  const userMenu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Log out
      </Menu.Item>
    </Menu>
  );

  return (
    <S.CrmXHeaderContainer>
      <S.CrmXHeaderWrapper>
        {/* Logo Section */}
        <S.CrmXLogoSection>
          <S.CrmXLogoText>Teacher's Space</S.CrmXLogoText>
        </S.CrmXLogoSection>

        {/* Spacer */}
        <div style={{ flex: 1 }} />

        {/* Right Section: Language + Auth */}
        <S.CrmXIconsSection>
          {/* Language Switcher */}
          <LanguageSwitcher variant="light" />
          
          {/* Auth Button/Dropdown - показывается сразу */}
          {isAuthenticated ? (
            <Dropdown overlay={userMenu} trigger={['hover']} placement="bottomRight">
              <S.AuthButton $isAuthenticated={true}>
                <UserOutlined />
                <span>{userName || 'User'}</span>
              </S.AuthButton>
            </Dropdown>
          ) : (
            <>
              <S.AuthButton onClick={handleLogin} $isAuthenticated={false}>
                <LoginOutlined />
                <span>Sign In</span>
              </S.AuthButton>
              {/* Uncomment if you want Register button
              <S.AuthButton onClick={handleRegister} $isAuthenticated={false} style={{ marginLeft: 8 }}>
                <UserOutlined />
                <span>Register</span>
              </S.AuthButton>
              */}
            </>
          )}
        </S.CrmXIconsSection>
      </S.CrmXHeaderWrapper>
    </S.CrmXHeaderContainer>
  );
};
